import { createContext } from "react";
import { Booking } from "../interface/Booking";

export type BookingCalendar = {
  bookings: Booking[];
  currentDate: string;
  dates: string[];
  setCurrentDate: (date: string) => void;
  fetchNextPage: () => void;
  canFetchMore: boolean;
  isLoading: boolean;
  redirectUrl: string;
};

export const generateDates = (): string[] => {
  const dates = [];
  for (let i = 0; i < 7; i += 1) {
    const today = new Date();
    today.setDate(today.getDate() + i);
    dates.push(today.toISOString());
  }

  return dates;
};

export const initialValue: BookingCalendar = {
  bookings: [],
  currentDate: new Date().toISOString(),
  dates: generateDates(),
  setCurrentDate: () => {},
  fetchNextPage: () => {},
  canFetchMore: false,
  isLoading: false,
  redirectUrl: "https://membr.com",
};

export const BookingCalendarContext =
  createContext<BookingCalendar>(initialValue);

export const {
  Provider: BookingCalendarProvider,
  Consumer: BookingCalendarConsumer,
} = BookingCalendarContext;
